import { useCompanyId } from "../../core";
import { Grid } from "semantic-ui-react";
import {
  getAllWorkflowLogsByType,
} from "./amProjectSync.client";
import { ExecutionLogs } from "./ExecutionLogs";
import { EntityCrud, buildEntityDef } from "../../ui/crud/EntityCrud.component";
import { timeAgo } from "./ProjectDetail.page";
import { ContentPopup } from "../../ui/popup/ContentPopup";
import { usePopup } from "../../ui/popup/Popup";
import { ProjectVersionExecutionLogEntry } from "../../ps-types";

export function WorkflowLogsEntityCrud({type, executionId}: {type: ProjectVersionExecutionLogEntry['type'], executionId: string}) {
  const companyId = useCompanyId();
  let { openPopup, closePopup } = usePopup();
  
  const getEntities = () => getAllWorkflowLogsByType(companyId, type);

  const closePopupFun = () => {
    closePopup();
  }

  const LogsContent = (data: any) => {
    let openPopupContent = (
      <ContentPopup header="Logs" onClose={closePopupFun}>
        <Grid.Row>
          <ExecutionLogs
            executionId={data.data.executionId}
            projects={[]}
            initialJobProgress={{
              logEntries: [],
              total: 0,
            }}
          />
        </Grid.Row>
      </ContentPopup>
    );
    return (
      <p
        style={{ cursor: "pointer", color: "#9b51e0" }}
        onClick={() => openPopup(openPopupContent)}
      >
        {data.data.executionId}
      </p>
    );
  };

  let def = buildEntityDef(
    {
      entityName: "Workflow Trigger History",
      title: "Workflow Trigger History",
      getEntities,
    },
    {
      executionId: {
        title: "Execution Id",
        table: {
          render: (_value: string, spv) => <LogsContent data={spv} />,
        },
      },
      status: {
        create: { type: "hidden" }
      },
      createdAt: {
        title: "Created At",
        table: { format: timeAgo },
        create: { type: "hidden" },
      },
    }
  );

  return (
    <div style={{ margin: "20px 0px" }}>
      <EntityCrud entityDef={def} />
    </div>
  );
}
